// extracted by mini-css-extract-plugin
export default {"rowHeader":"DashboardReportSexAgeTable_rowHeader__QRwM0","columnHeader":"DashboardReportSexAgeTable_columnHeader__sO2eZ","table":"DashboardReportSexAgeTable_table__ZdNuo"};